import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { ShareIcon, InstagramIcon, YoutubIcon, XIcon, FacebookIcon, PrintIcon } from "../../../../resources/js/components/svgIcon";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import "./inner-banner.scss";
import CommonCrypt from '../Common/CommonCrypt';
import InnerBannerImg from "../../../assets/images/inner-banner.jpg";
import { FacebookShareButton, TwitterShareButton, InstapaperShareButton } from "react-share";


function InnerBanner({ InnerBanner, Pagedata, Breadcrumbs, Constant }) {
    const [isOpen, setIsOpen] = useState(false);
    const APP_URL = window.site_url;
    const  route  = useParams();
    const [images, setImages] = useState({}); // Store images in state
    const [isLoading, setIsLoading] = useState(true);
    const hasInnerBanner = Array.isArray(InnerBanner) && InnerBanner.length > 0;
    // Function to fetch image URLs
    const GetImageWebp = async (imageId, width, height, flag) => {
        if (!imageId) return null;
        setIsLoading(true);
        const data = { imageId, width, height, flag };
        try {
            const response = await fetch(`${APP_URL}/api/webpImageID`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const image_data = await response.json();
            return JSON.parse(CommonCrypt(image_data.image_result)); // Parse JSON response
        } catch (error) {
            console.error("Error fetching image:", error);
            return null;
        }
    };
    const [shareUrl, setShareUrl] = useState("");

    useEffect(() => {
      setShareUrl(window.location.href); // Set the URL dynamically
    }, []);
    // Fetch images once Newsdata is available
    useEffect(() => {
        const fetchImages = async () => {
            const imagesData = {};
            for (let item of InnerBanner) {
                const image = await GetImageWebp(item?.fkIntInnerImgId, 1920, 550, false);
                imagesData[item?.fkIntInnerImgId] = image ?.webp || image ?.image;
            }
            setImages(imagesData);
        };

        if (InnerBanner) {
            fetchImages();
            setIsLoading(false);
        }
    }, [InnerBanner]);

    return (
        <>
            {hasInnerBanner ? (
                InnerBanner?.map((value, index) => (
                    <>
                        <section className="section-gap inner-banner" key={index} data-aos="fade">
                        <div className="caption position-relative text-center">
                            <Container>
                                        <h1 className="text-uppercase title fw-normal">
                                            {value?.varTitle ? value?.varTitle : Pagedata?.varTitle}{" "}
                                            {value?.varSubTitle && <span>{value?.varSubTitle}</span>}
                                        </h1>
                                        {value?.varSubTitle && (
                                            <div className="p-tag ff-2 mt-4 text-white">{value?.varSubTitle}</div>
                                        )}

                            </Container>
                        </div>

                            <div className="bg-image">
                                {images[value?.fkIntInnerImgId] ? (
                                    <Image
                                        src={images[value?.fkIntInnerImgId]}
                                        alt={value?.varTitle}
                                        title={value?.varTitle}
                                        width={1920}
                                        height={818}
                                    />
                                ) : (
                                        <p>Loading image...</p>
                                    )}
                            </div>
                        </section>

                        {(route.route != 'thank-you' && route.route != 'search') && Breadcrumbs && index == 0 ? (
                            <div className="inner-banner-bottom my-4 d-none d-lg-block">
                                <div className="container">
                                    <div className=" justify-content-between d-flex align-items-center">
                                        <ul className="custom-breadcrumb fs-base fw-normal me-lg-6 me-2 d-none d-lg-block" >
                                            {
                                                Breadcrumbs && Breadcrumbs?.map((value, index) => (
                                                    <li key={index}>
                                                        {value?.link ? (
                                                            <Link to={value?.link} title={value?.title}>{value?.title}</Link>
                                                        ) : value?.title }
                                                    </li>
                                                ))
                                            }
                                        </ul>

                                        <div className="right-panel d-none d-lg-flex justify-content-lg-end">
                                            <div className="position-relative">
                                                <ul className="list-unstyled d-flex">
                                                    <li>
                                                        <Link className="" to="/">
                                                            <i className="share-icon">
                                                                <ShareIcon />
                                                            </i>
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : ('')}

                    </>
                ))
            ) : (
                    <>
                        <section className="inner-banner" data-aos="fade">
                            <div className="caption position-relative text-center">
                                <div className="container">
                                    {route.route == 'search' ? (
                                        <h1 className="text-uppercase title fw-normal">
                                            Search
                                        </h1>
                                    ) :
                                    <>
                                    <h1 className="text-uppercase title fw-normal">
                                        {Pagedata ?.varTitle}
                                    </h1>
                                    </>
                                    }
                                </div>
                            </div>
                            <div className="bg-image">
                                <img src={cdn_path + 'assets/images/inner-banner.jpg'} alt={Constant?.SITE_NAME} />
                            </div>
                        </section>
                        {(route.route != 'thank-you' && route.route != 'search') && Breadcrumbs ? (
                            <div className="inner-banner-bottom my-4 d-none d-lg-block">
                                <div className="container">
                                    <div className=" justify-content-between d-none d-md-flex align-items-center">
                                        <ul className="custom-breadcrumb fs-base fw-normal me-lg-6 me-2 ">
                                            {
                                                Breadcrumbs && Breadcrumbs?.map((value, index) => (
                                                    <li key={index}>
                                                        {value ?.link ? (
                                                            <Link to={value?.link} title={value?.title}>{value?.title}</Link>
                                                        ) : value?.title }
                                                    </li>
                                                ))
                                            }
                                        </ul>
                                        <div className="right-panel d-flex justify-content-end">
                                            <div className="position-relative">
                                                <ul className="list-unstyled d-flex">
                                                    <li>
                                                        <div className="dropdown">
                                                            <div className="dropdown-button" onClick={() => setIsOpen(!isOpen)}>
                                                                <i className="share-icon">
                                                                    <ShareIcon />

                                                                </i>
                                                            </div>
                                                            <ul className={`dropdown-menu social-icon ${isOpen ? "show" : ""}`}>
                                                                {
                                                                Constant?.SOCIAL_FB_LINK ? (
                                                                <li>
                                                                    <i className="facebook">
                                                                    <FacebookShareButton url={shareUrl} hashtag="#YourBrand">
                                                                         <FacebookIcon size={32} round />
                                                                    </FacebookShareButton>
                                                                    </i>
                                                                </li>) : ''
                                                                }
                                                                {
                                                                Constant?.SOCIAL_TWITTER_LINK ? (<li>
                                                                    <i className="twitter">
                                                                        <TwitterShareButton url={shareUrl}>
                                                                            <XIcon size={32} round />
                                                                        </TwitterShareButton>

                                                                    </i>
                                                                </li>) : ''
                                                                }

                                                                {/* {
                                                                Constant?.SOCIAL_INSTAGRAM_LINK ? (
                                                                <li>
                                                                    <i className="instagram">
                                                                        <InstapaperShareButton url={shareUrl}>
                                                                            <InstagramIcon size={32} round />
                                                                        </InstapaperShareButton>
                                                                    </i>
                                                                </li>) : ''
                                                                } */}
                                                            </ul>
                                                        </div>
                                                    </li>
                                                    {/* <li>
                                                        <Link className="" to="/">
                                                            <i className="print-icon">
                                                                <PrintIcon />
                                                            </i>
                                                        </Link>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : ''}
                    </>
                )}
        </>
    );
}

export default InnerBanner;
